import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
export const USD_SIGN = "$";
const { carbon, blue } = colorsPalettes;

export const LINE_BACKGROUND_COLOR = {
    positive: `linear-gradient(90deg, ${carbon[50]} 0%, ${blue[300]} 100%)`,
    negative: `linear-gradient(90deg, ${blue[300]} 0%, ${carbon[50]} 100%)`,
};

export const OVERVIEW_PPC_TEXT = {
    paidVisits: translate("analysis.source.search.overview.ppc.spend.widget.paid.visits"),
    ppcSpend: translate("analysis.source.search.overview.ppc.spend.widget.ppc.spend"),
    costPerVisit: translate("analysis.source.search.overview.ppc.spend.widget.cost.per.visit"),
    title: translate("analysis.source.search.overview.ppc.spend.widget.title"),
    tooltip: translate("analysis.source.search.overview.ppc.spend.widget.tooltip"),
};
